import { ReactNode } from 'react';

import {
  Privileges,
  CLIENT_STATUS,
  CheckIfUserHasApiPrivilege,
  CheckIfUserHasPortalPrivilege,
  GetClientStatusProps,
  UserAccount
} from './interfaces';
import { useGetClientStatus } from './useGetClientStatus';

import { ClientStatusContext } from './clientStatusContext';

interface Props {
  children: ReactNode;
  initPrivileges: Privileges;
  initClientStatus: CLIENT_STATUS;
  userAccount: UserAccount;
}

export const WithClientStatus = ({ children, initPrivileges, initClientStatus, userAccount }: Props) => {
  const { privileges, clientStatus, handleGetClientStatus } = useGetClientStatus({
    initPrivileges,
    initClientStatus
  });

  const { api, portal } = privileges;

  const checkIfUserHasApiPrivilege: CheckIfUserHasApiPrivilege = userApiPrivilege => api.includes(userApiPrivilege);

  const checkIfUserHasPortalPrivilege: CheckIfUserHasPortalPrivilege = userPortalPrivilege =>
    portal.includes(userPortalPrivilege);

  const getClientStatus = (props: GetClientStatusProps) => handleGetClientStatus(props);

  return (
    <ClientStatusContext.Provider
      value={{
        checkIfUserHasApiPrivilege,
        checkIfUserHasPortalPrivilege,
        getClientStatus,
        clientStatus,
        userAccount
      }}
    >
      {children}
    </ClientStatusContext.Provider>
  );
};
